import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSyncExternalStore } from 'react';
import { getOwnerProfileById, getSession, subscribeSession } from '../data/authStore';

type GuardProps = {
  children: React.ReactNode;
};

export const RequireOwnerApproved: React.FC<GuardProps> = ({ children }) => {
  const location = useLocation();
  const session = useSyncExternalStore(subscribeSession, getSession, getSession);

  if (!session) {
    return <Navigate to="/giris" state={{ from: location.pathname }} replace />;
  }
  if (session.role !== 'owner') {
    return <Navigate to="/profil" replace />;
  }

  const owner = getOwnerProfileById(session.ownerId);
  if (!owner || owner.status !== 'approved' || owner.suspended) {
    return <Navigate to="/profil" replace />;
  }

  return <>{children}</>;
};
